import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import ColorPink from 'src/assets/Color_Pink.svg';
import { PATH } from 'src/constants';
import autoPayment, { AutoPaymentStore } from 'src/stores/AutoPaymentStore';
import Button, { ButtonTypes } from '../../components/Button';
import './style.scoped.css';
import { AutoDebitItem } from '../../models/AutoDebit';
import { CancelRegisterState } from '../CancelRegister';

interface AutoPaymentObserverProps {
  store?: AutoPaymentStore;
}

interface CardProps {
  productId?: string,
  clickShowDetail?: () => void,
  clickCancel?: () => void,
  phName?: string
}

const Card = observer((props: CardProps) => {
  const { productId, clickShowDetail, clickCancel, phName } = props;
  const { t } = useTranslation();
  const [showDetail, setShowDetail] = useState(false);

  return (
    <div className="wapper_card mb-4">
      <div className="item">
        <div className={`item-view cl-pink p-10ct`}>
          <div className="layout-top">
            <div className="lf">
            </div>
            <div className="rf">
              <div className="title pb-5px">
                {t('contract_number')}
              </div>
              <div className="number-phone">
                {productId ?? '- - -'}
              </div>
            </div>
          </div>
          <div className="layout-buttom">
            <div className="lf">
              <div className="title-buy">
                {t('insurance_buyer')}
              </div>
              <div className="name-buy">
                {phName || '- - -'}
              </div>
            </div>
            <div className="rf">
              <div className="logo-ct">
              </div>
            </div>
          </div>

          <div className="btn-detail">
            <button className="icon-btn" onClick={() => setShowDetail(!showDetail)}>
              <i className={'arrow-ct' + (!showDetail ? ' down-ct' : ' up-ct')}></i>
            </button>
          </div>
          <div className="bg-cl-ping">
            <img src={ColorPink} alt="" className="w-100" />
          </div>
        </div>
        {
          showDetail && (
            <div className="show-detail">
              <div className={'show-detail-top border border-line border-radius-bottom'}>
                <Button
                  text={t('detail_register')}
                  onClick={() => clickShowDetail()}
                  extraClassName={'w-full'}
                />
                <Button
                  buttonType={ButtonTypes.errorBorderless}
                  text={t('cancel_register')}
                  onClick={() => clickCancel()}
                  extraClassName={'text-red w-full mt-3'}
                />
              </div>
            </div>
          )
        }
      </div>
    </div>
  );
});

const AutoPaymentObserver = observer(({ store }: AutoPaymentObserverProps) => {
  const { t } = useTranslation();
  const history = useHistory();

  const [autoDebits, setAutoDebits] = useState<AutoDebitItem[]>([]);

  useEffect(() => {
    store?.getAutoDebits().then((res) => {
      setAutoDebits(res)
    }).catch((err) => {})
  }, []);

  const _handleRegisterAutoPayment = () => {
    history.push(PATH.REGISTER_AUTO_PAYMENT, {autoDebits});
  };

  const doDetail = (policyNumber: string) => {
    history.push(PATH.DETAIL_AUTO_PAYMENT, { policyNumber });
  };

  const doCancel = ({productId, autoDebitId, recordId}: AutoDebitItem) => {
    history.push(PATH.CANCEL_REGISTER, {
      policyNumber: productId,
      autoDebitId,
      recordId
    } as CancelRegisterState);
  };

  return (
    <div className="roundContent">
      <Button
        text={t('auto_payment_button')}
        onClick={_handleRegisterAutoPayment}
        extraClassName={'w-full'}
        disabled={false}
      />
      <div className="bg-surface px-2 pt-4 pb-4 mt-4 border-b border-line">
        <div className="text-base font-bold text-onSurface">
          {`${t('auto_payment_list')} (${autoDebits?.length ?? 0})`}
        </div>
      </div>
      <div className="bg-surface pt-4 pb-4 mb-8">
        <div className="mb-5">
          <div className="bg-surface py-4 mb-8">
            <div className="mb-5">
              {autoDebits?.length
                ? autoDebits.map((policy, index) => (
                  <div className="p-3" key={index}>
                    <Card
                      clickShowDetail={() => doDetail(policy?.productId)}
                      clickCancel={() => doCancel(policy)}
                      {...policy}
                    />
                  </div>
                ))
                : <div className={'px-4'}>{t('no_policy')}</div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

const AutoPayment = () => <AutoPaymentObserver store={autoPayment} />;
export default AutoPayment;


